module.exports = __webpack_public_path__ + "img/urbi-04.e74bc699.jpg";